import type { RefinementType } from '@sorare/core/src/contexts/graphql-search';

/** URL param keys for virtual filters handled outside simple search params to api filters mapping. */
export const GQL_SEARCH_FILTERS = {
  leagueFilter: 'lf',
  notInLineupFilter: 'nl',
  watchlistFilter: 'wl',
  gameweekFilter: 'gw',
  duplicateFilter: 'dk',
  dailyFilter: 'dly',
} as const;

export const BACKEND_FILTERS = {
  ps: { api: 'player.playing_status', type: 'string' },
  pos: { api: 'position', type: 'string' },
  gw: { api: 'playing_next', type: 'string' },
  dly: { api: 'playing_next', type: 'string' },
  'fp-is-l': { api: 'floor_prices.in_season.limited', type: 'numeric' },
  'fp-is-r': { api: 'floor_prices.in_season.rare', type: 'numeric' },
  'fp-is-sr': { api: 'floor_prices.in_season.super_rare', type: 'numeric' },
  'fp-is-u': { api: 'floor_prices.in_season.unique', type: 'numeric' },
  'fp-as-l': { api: 'floor_prices.all_seasons.limited', type: 'numeric' },
  'fp-as-r': { api: 'floor_prices.all_seasons.rare', type: 'numeric' },
  'fp-as-sr': { api: 'floor_prices.all_seasons.super_rare', type: 'numeric' },
  'fp-as-u': { api: 'floor_prices.all_seasons.unique', type: 'numeric' },
  'mv-is-l': { api: 'market_values.in_season.limited', type: 'numeric' },
  'mv-is-r': { api: 'market_values.in_season.rare', type: 'numeric' },
  'mv-is-sr': { api: 'market_values.in_season.super_rare', type: 'numeric' },
  'mv-is-u': { api: 'market_values.in_season.unique', type: 'numeric' },
  'mv-c-l': { api: 'market_values.classic.limited', type: 'numeric' },
  'mv-c-r': { api: 'market_values.classic.rare', type: 'numeric' },
  'mv-c-sr': { api: 'market_values.classic.super_rare', type: 'numeric' },
  'mv-c-u': { api: 'market_values.classic.unique', type: 'numeric' },
  player: { api: 'player.display_name', type: 'string' },
  age: { api: 'player.birth_date_i', type: 'numeric' },
  nationality: {
    api: lang => `country.name_with_code_${lang}`,
    type: 'string',
  },
  club: { api: `active_club.long_name_with_slug`, type: 'string' },
  nt: { api: lang => `active_national_team.name_${lang}`, type: 'string' },
  al: { api: lang => `active_leagues.name_with_slug_${lang}`, type: 'string' },
  so5L5Avg: { api: 'so5.last_five_so5_average_score', type: 'numeric' },
  so5L10Avg: { api: 'so5.last_ten_played_so5_average_score', type: 'numeric' },
  so5L15Avg: { api: 'so5.last_fifteen_so5_average_score', type: 'numeric' },
  so5L5App: { api: 'so5.last_five_so5_appearances', type: 'numeric' },
  so5L10App: { api: 'so5.last_ten_played_so5_appearances', type: 'numeric' },
  so5L15App: { api: 'so5.last_fifteen_so5_appearances', type: 'numeric' },
  cfPrSc: { api: 'next_classic_fixture_projected_score', type: 'numeric' },
  cfPrGain: { api: 'gain_on_classic_projection', type: 'numeric' },
  dyPrSc: { api: 'next_daily_fixture_projected_score', type: 'numeric' },
  dyPrGain: { api: 'gain_on_daily_projection', type: 'numeric' },
  ff: { api: 'ff', type: 'virtual' },
  [GQL_SEARCH_FILTERS.leagueFilter]: { api: 'lf', type: 'virtual' },
} satisfies Record<
  string,
  {
    api: string | ((lang: string) => string);
    type: RefinementType;
  }
>;
